import { createContext } from "react";
import type { V2Space } from "../types";

export interface SpaceContextValue {
  spaces: V2Space[];
  selectedSpace: V2Space;
  selectSpace: (id: string) => void;
}

// Keep context identity outside the provider's UI dependency graph. Hot updates
// can retain the mounted provider while replacing a consumer such as ProjectSwitcher.
export const SpaceContext = createContext<SpaceContextValue | null>(null);
